import { MarkerClusterer } from "./google_clusterer";

const mapInit = () => {

  // ALL GLOBAL VARIABLES
  const divMap = document.getElementById('map');
  const screenWidth = window.screen.width;
  const allMarkersAc = JSON.parse(divMap.dataset.markersActivity);
  const allMarkersPoi = JSON.parse(divMap.dataset.markersPoi);
  let lastInfoWindow = new google.maps.InfoWindow();
  const myMarkers = allMarkersAc.concat(allMarkersPoi);


  // Coordinates to prevent map to pan out of Martinique
  const MARTINIQUE_BOUNDS = {
    north: 15.13978861563618,
    south: 14.16887901980523,
    west: - 61.72161842946184,
    east: - 60.33835857736076
  };

  const styledMapType = new google.maps.StyledMapType(
    [{ "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#444444" }] }, { "featureType": "administrative.country", "elementType": "geometry", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.country", "elementType": "geometry.fill", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.country", "elementType": "geometry.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.province", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.locality", "elementType": "labels", "stylers": [{ "hue": "#ffe500" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }, { "visibility": "on" }] }, { "featureType": "landscape.natural", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape.natural.landcover", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape.natural.terrain", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape.natural.terrain", "elementType": "geometry", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape.natural.terrain", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape.natural.terrain", "elementType": "geometry.stroke", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape.natural.terrain", "elementType": "labels", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape.natural.terrain", "elementType": "labels.text", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape.natural.terrain", "elementType": "labels.text.fill", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape.natural.terrain", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape.natural.terrain", "elementType": "labels.icon", "stylers": [{ "visibility": "on" }] }, { "featureType": "poi", "elementType": "labels.text", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.attraction", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.business", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.place_of_worship", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "poi.school", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }, { "visibility": "on" }] }, { "featureType": "road", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "stylers": [{ "visibility": "on" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#9bdffb" }, { "visibility": "on" }] }],
    { name: "Styled Map" }
  );

  // MAIN FONCTION
  if (divMap) {
    // const map = map.load(divMap, screenWidth);

    let map = new google.maps.Map(divMap);

    if (screenWidth < 975) {
      map = new google.maps.Map(divMap, {
        zoom: 10,
        center: { lat: 14.542433070007407, lng: -61.01234487406716 },
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT,
        },
        scaleControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        mapTypeControlOptions: {
          mapTypeIds: ["styled_map"],
        },
        gestureHandling: "greedy",
        restriction: {
          latLngBounds: MARTINIQUE_BOUNDS,
          strictBounds: false,
        },
      });
    } else {
      map = new google.maps.Map(divMap, {
        zoom: 10,
        restriction: {
          latLngBounds: MARTINIQUE_BOUNDS,
          strictBounds: false,
        },
      });
    }

    const latlngbounds = new google.maps.LatLngBounds();

    const markers = myMarkers.map((position) => {
      position.lat = parseFloat(position.lat)
      position.lng = parseFloat(position.lng)

      const marker = new google.maps.Marker({
        position,
        label: {
          text: position.emoji,
          fontSize: "18px",
        },
        icon: {
          url: `${position.image_url}`,
          scaledSize: { width: 46, height: 54, widthUnit: 'px', heightUnit: 'px' },
          labelOrigin: new google.maps.Point(24, 22)
        }
      });

      latlngbounds.extend(marker.position);

      if (screenWidth < 975) {
        const infowindow = new google.maps.InfoWindow({
          content: position.info_window,
          minWidth: 320,
          disableAutoPan: true,
          pixelOffset: new google.maps.Size(0, 10),
          zIndex: 1000,
        });

        marker.addListener("click", () => {
          lastInfoWindow.close();
          infowindow.open({
            anchor: marker,
            map,
            shouldFocus: false,
          });
          lastInfoWindow = infowindow;
        });
        map.addListener("click", () => {
          infowindow.close();
        });
      }
      // else OPEN on hover
      else {
        const infowindow = new google.maps.InfoWindow({
          content: position.info_window,
          maxWidth: 250,
          pixelOffset: new google.maps.Size(0, 10),
          zIndex: 1000,
        });

        marker.addListener("mouseover", () => {
          infowindow.open({
            anchor: marker,
            map,
            shouldFocus: false,
          });
        });

        marker.addListener("mouseout", () => {
          infowindow.close();
        });

        // On click, redirect on activity or poi detail page
        marker.addListener("click", () => {
          window.location.href = position.url;
        });
      }

      //Center map and adjust Zoom based on the position of all markers.
      map.setCenter(latlngbounds.getCenter());
      map.fitBounds(latlngbounds);

      return marker;
    });

    // Custom map style
    map.mapTypes.set("styled_map", styledMapType);
    map.setMapTypeId("styled_map");

    new MarkerClusterer({ map, markers });
  }
}

export { mapInit };
